/**
 * Client-side display maps for known English API/DB values.
 * Does not change payloads — UI only.
 */

import { translateCategoryName } from './categoryLabel';

const PLAN_NAME_KEYS = {
  'TRADING PLAN': 'challenge.tradingPlan',
  'TESTING PLAN': 'challenge.testingPlan',
  'PIANO DI TRADING': 'challenge.tradingPlan',
  'PIANO DI TEST': 'challenge.testingPlan',
};

const THREE_DAY_SWAP_KEYS = {
  'No 3-days SWAP': 'orderPanel.noThreeDaySwap',
  'No 3-days swap': 'orderPanel.noThreeDaySwap',
  'No 3-day SWAP': 'orderPanel.noThreeDaySwap',
};

const SYMBOL_DESCRIPTION_KEYS = {
  'British Pound vs US Dollar': 'symbolDescriptions.gbpUsd',
};

const PHASE_STATUS_KEYS = {
  active: 'userSettings.active',
  failed: 'userSettings.failed',
  passed: 'userSettings.passed',
  completed: 'userSettings.completed',
};

const FAIL_REASON_KEYS = {
  overall_loss: 'notifications.msg.failReasonOverallLoss',
  daily_loss: 'notifications.msg.failReasonDailyLoss',
  duration_expired: 'notifications.msg.failReasonDurationExpired',
};

export function translatePlanName(name, t) {
  if (!name) return name;
  const mapped = PLAN_NAME_KEYS[String(name).trim().toUpperCase()];
  return mapped ? t(mapped) : name;
}

export function translateThreeDaySwap(value, t) {
  if (value == null || value === '') return value;
  const key = THREE_DAY_SWAP_KEYS[String(value).trim()];
  return key ? t(key) : value;
}

export function translateSymbolDescription(description, t) {
  if (!description) return description;
  const trimmed = String(description).trim();
  const key = SYMBOL_DESCRIPTION_KEYS[trimmed];
  if (key) return t(key);
  const asCategory = translateCategoryName(trimmed, t);
  if (asCategory !== trimmed) return asCategory;
  return trimmed;
}

export function translatePhaseStatus(status, t) {
  if (!status) return '';
  const raw = String(status).trim().toLowerCase();
  const key = PHASE_STATUS_KEYS[raw];
  if (key) return t(key);
  return raw.charAt(0).toUpperCase() + raw.slice(1);
}

/** Localize server fail_reason codes (overall_loss) or spaced forms (overall loss). */
export function translateFailReason(reason, t) {
  if (reason == null || reason === '') return '';
  const key = String(reason).trim().toLowerCase().replace(/\s+/g, '_');
  const mapped = FAIL_REASON_KEYS[key];
  if (mapped) return t(mapped);
  return String(reason).trim().replace(/_/g, ' ');
}

/** Localize "Phase N" / "Phase N Funded" / "Funded" built by getChallengePhaseLabel. */
export function localizeChallengePhaseLabel(label, t) {
  if (!label) return label;
  const fundedMatch = String(label).match(/^Phase\s+(\d+)\s+Funded$/i);
  if (fundedMatch) return t('challenge.phaseNFunded', { n: fundedMatch[1] });
  const phaseMatch = String(label).match(/^Phase\s+(\d+)$/i);
  if (phaseMatch) return t('challenge.phaseN', { n: phaseMatch[1] });
  if (/^Funded$/i.test(label)) return t('orderPanel.funded');
  return label;
}
